import { injectable, inject } from "inversify";
import TYPES from "@/ioc/identifiers";
import { IBookRepository } from "@/repositories/book/bookRepository.types";
import { BookIntervalCode } from "@/types";
import { GetMonthlyBookableDates } from "../GetMonthlyBookableDates";
import { GetDailyBookableDates } from "../GetDailyBookableDates";
import { BookableDatesUseCase } from "../interface/BookableDatesUseCase";
import { IsDailyBookCheaperUseCase } from "../IsDailyBookCheaper";

@injectable()
export class GetBookableDatesFactory {
  constructor(
    @inject(TYPES.IBookRepository) private bookRepository: IBookRepository,
    @inject(TYPES.IsDailyBookCheaperUseCase)
    private isDailyBookCheaper: IsDailyBookCheaperUseCase
  ) {}

  create(
    bookIntervalCode: BookIntervalCode,
    dailyFare?: number,
    monthlyFare?: number
  ): BookableDatesUseCase {
    if (bookIntervalCode === BookIntervalCode.MONTH) {
      // 월예약
      if (dailyFare === undefined || monthlyFare === undefined) {
        throw new Error("Daily Fare & Monthly Fare must be required!");
      }

      return new GetMonthlyBookableDates(
        this.bookRepository,
        dailyFare,
        monthlyFare,
        this.isDailyBookCheaper
      );
    } else {
      // 일예약
      return new GetDailyBookableDates(this.bookRepository);
    }
  }
}
